// Static product configuration for the SAA Rechtsbijstand calculation payload
// (Anker Eigen Jurist Polis Optimaal). Mirrors the doorlopendereis/fields.ts shape — these
// values were previously hardcoded inline across RechtsbijstandScreen's buildCalculationPayload.

export const RBV_PRODUCT = {
  carrierCode: 'P020',
  productName: 'Anker EJP Optimaal',
  branchCode: '092',
  ppMyaand: 'P020',
  afdDefn: '092-P020-Anker EJP Optimaal',
  adefVrs: '007.00',
  veMyaand: 'K781',
  // AL_APPLNM on the wire. TODO(S2): source from config.branding instead of this literal —
  // it is a payload value, so the swap must be checked against the baseline byte-diff
  // (deferred while the BFF is unreachable).
  appName: 'SAA Verzekeringen',
} as const;

// PP-level defaults that don't depend on user input.
export const RBV_PP_DEFAULTS = {
  PP_HANDACC: 'N',
  PP_STPRV: 'J',
  PP_PPRC: 20,
  PP_EKST: 0,
  PP_CDUUMND: 12,
  PP_BTWCD: 'I',
  PP_INCWIJZ: 'I',
} as const;

export const RBV_IN_EIGBVAK_DEFAULT = 250;

// Request/enrich-path subset of RBV_PP_DEFAULTS: the schema defaults both wire
// touchpoints (summary/enrich.ts and ConfirmationScreen) must agree on, applied
// there via applyPpDefaults instead of duplicated literals.
export const RBV_PP_REQUEST_DEFAULTS: Record<string, string | number> = {
  PP_CDUUMND: RBV_PP_DEFAULTS.PP_CDUUMND,
  PP_BTWCD: RBV_PP_DEFAULTS.PP_BTWCD,
};

// Acceptance/risk block — all 'N' for the calc; the real answers are collected later on the
// acceptance-questions screen.
export const RBV_RI_DEFAULTS = {
  RI_ALGVRWD: 'N',
  RI_BGP: 'N',
  RI_BYZVRWE: 'N',
  RI_DGP: 'N',
  RI_EGD: 'N',
  RI_GEWEIGE: 'N',
  RI_NGP: 'N',
  RI_SCHADV: 'N',
  RI_STRAFRV: 'N',
} as const;
